'use client'
import { useUserQuery } from 'auth/hooks'
import { IconButton } from 'primitives/buttons/icon-button'
import { tw } from 'utils/classnames'
import { Link } from '@repo/web-ui/components/link'
import { useCopyToClipboard } from '../../_hooks/use-clipboard'
import { IconCopyAll } from '@repo/design-system-cf/components/icons'
import { useUserCapabilitiesQuery } from '@web/gen/user'
import { AppRoutes } from '@repo/web-utils/app-routes'

const VIEW_ADMIN_DASHBOARD_CAPABILITY = 'view_admin_dashboard'

export function CopyUserIdButton({ userId, className }: { userId: string; className?: string }) {
  const { data } = useUserQuery(undefined, {
    select: ({ me }) => ({
      isCFUser: me?.user?.email?.endsWith('@creativefabrica.com'),
    }),
  })
  const { data: userCapabilities } = useUserCapabilitiesQuery(undefined, {
    select: data => data?.me?.user,
  })
  const showAdminDashboardLink = !!userCapabilities?.capabilities.includes(
    VIEW_ADMIN_DASHBOARD_CAPABILITY,
  )
  const adminDashboardLink = `${AppRoutes.ADMIN_DASHBOARD_BY_USER_ID}/?exactemail=&userid=${userId}&orderid=&subscriptionid=&licensekey=&affiliateid=&email=`

  const { isCFUser = false } = data ?? {}
  const copyToClipboard = useCopyToClipboard()

  return isCFUser ? (
    <div className={tw('text-cf-sf-gray-200 flex items-center', className)}>
      {showAdminDashboardLink ? (
        <Link className="text-cf-sf-blue-100" target="_blank" href={adminDashboardLink}>
          (ID: {userId})
        </Link>
      ) : (
        <span>({userId})</span>
      )}
      <IconButton
        variant="transparent"
        className="size-6 outline-none"
        onClick={() => copyToClipboard(userId)}
      >
        <IconCopyAll className="size-4" />
      </IconButton>
    </div>
  ) : null
}
